var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { from, Observable, range, throwError, timer } from 'rxjs';
import { catchError, flatMap, retryWhen, share, switchMap, take, tap, zip } from 'rxjs/operators';
export function createShareRefreshing() {
    var resource = null;
    return function (fn) {
        if (resource) {
            return resource;
        }
        resource = fn().pipe(tap(function () {
            resource = null;
        }), catchError(function (err) {
            resource = null;
            throw err;
        }), share());
        return resource;
    };
}
function isNeedRetryDefault(err) {
    return err.status === 503;
}
var TokenManager = /** @class */ (function () {
    function TokenManager(token, config) {
        if (config === void 0) { config = {}; }
        var _a, _b, _c, _d, _e, _f;
        this.token = token;
        this.shareRefreshing = createShareRefreshing();
        this.retryOptions = {
            isNeedRetry: (_b = (_a = config.retry) === null || _a === void 0 ? void 0 : _a.isNeedRetry) !== null && _b !== void 0 ? _b : isNeedRetryDefault,
            retryCount: (_d = (_c = config.retry) === null || _c === void 0 ? void 0 : _c.retryCount) !== null && _d !== void 0 ? _d : 3,
            timeout: (_f = (_e = config.retry) === null || _e === void 0 ? void 0 : _e.timeout) !== null && _f !== void 0 ? _f : 1000
        };
    }
    TokenManager.prototype.run = function (task) {
        var _this = this;
        var runTask = function (accessToken) {
            try {
                var stream = task(accessToken);
                if (!stream && stream !== 0) {
                    return throwError(new Error('RequestManager error: bad return value from task'));
                }
                return from(stream);
            }
            catch (err) {
                return throwError(err);
            }
        };
        return new Observable(function (observer) {
            (function () { return __awaiter(_this, void 0, void 0, function () {
                var token, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, this.token.getValue()];
                        case 1:
                            token = (_a.sent()) || '';
                            if (!token) {
                                throw new Error('RequestManager error: token not exist');
                            }
                            observer.next(runTask(token));
                            return [3 /*break*/, 3];
                        case 2:
                            e_1 = _a.sent();
                            e_1.status = 401;
                            observer.error(e_1);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); })();
        }).pipe(switchMap(function (v) { return v; }), retryWhen(function (attempts) {
            return attempts.pipe(zip(range(1, 2)), flatMap(function (_a) {
                var error = _a[0], count = _a[1];
                if (count > 1) {
                    return throwError(error);
                }
                if (error.status === 401) {
                    return from(_this.token.hasToken()).pipe(switchMap(function (hasToken) {
                        if (hasToken) {
                            return _this.shareRefreshing(function () {
                                return from(_this.token.refresh()).pipe(catchError(function (err) {
                                    _this.token.clear();
                                    err.status = 401;
                                    return throwError(err);
                                }));
                            }).pipe(take(1));
                        }
                        return throwError(error);
                    }));
                }
                return throwError(error);
            }));
        }), retryWhen(function (attempts) {
            return attempts.pipe(zip(range(1, _this.retryOptions.retryCount)), flatMap(function (_a) {
                var error = _a[0], count = _a[1];
                if (count > 3) {
                    return throwError(error);
                }
                if (_this.retryOptions.isNeedRetry(error)) {
                    return timer(count * _this.retryOptions.timeout);
                }
                return throwError(error);
            }));
        }));
    };
    return TokenManager;
}());
export { TokenManager };
//# sourceMappingURL=TokenManager.js.map